import * as React from 'react';
import RegistrationForm from '../containers/RegistrationForm';

export default (props) => (<RegistrationForm {...props} />);